import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import moment from "moment";

// component
import {
  errorSwal,
  successDeleteSwal,
  successSwal,
  successUpdateSwal,
} from "../../../helper/sweetalert";
import CustomButton from "../../../components/CustomButton";
import AnimationLoading from "../../../components/Animationloading";
import EmptyComponent from "../../../components/EmptyComponent";
import PaginationHelper from "../../../components/PaginationHelper";

// apollo
import { useLazyQuery, useMutation } from "@apollo/client";
import { USER_KEY } from "../../../const";
import {
  CREATE_USER,
  DELETE_USER,
  UPDATE_USER,
} from "../../../apollo/user/mutation";
import ConfirmDelete from "../../../components/ConfirmDelete";

// icon
import AddBoxOutlinedIcon from "@mui/icons-material/AddBoxOutlined";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { RiDeleteBin6Line } from "react-icons/ri";
import { MdOutlineBorderColor } from "react-icons/md";
import SearchIcon from "@mui/icons-material/Search";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";

// react bootrap
import { Form, Modal, Spinner, Table } from "react-bootstrap";
import { GET_USERS } from "../../../apollo/user/query";
import { Formik } from "formik";
import { toast } from "react-toastify";

function EmployeeManage() {
  // ==========> useHistory <===========
  const history = useHistory();
  //=============> useState <=============
  const [user, setUser] = useState();
  const [userTotal, setUserTotal] = useState();
  const [userKey, setUserKey] = useState();
  // ==========> modal Add <==========
  const [showAddUser, setshowAddUser] = useState(false);

  // ==========> modal edit <==========
  const [showEditUser, setShowEditUser] = useState(false);

  // ==========> modal delete <==========
  const [showDelete, setShowDelete] = useState(false);
  const [Delete, setDelete] = useState("");

  // ===============> Checkboxes <==================
  const [checkboxesState, setCheckBoxesState] = useState(false);
  const [countCheck, setCountCheck] = useState(false);

  // ===============> EditUserState <==================
  const [userKeyIndex, setUserKeyIndex] = useState();

  // ===============> Hover bell color <==================
  const [colorBell, setColorBell] = useState("");


  // ==========> Apollo <==============
  const shopId = JSON.parse(localStorage.getItem(USER_KEY))?.data?.shop?.id;
  const [createUser, { loading: loadingCreate }] = useMutation(CREATE_USER);
  const [deleteUser, { loading: loadingDelete }] = useMutation(DELETE_USER);
  const [updateUser, { loading: loadingUpdate }] = useMutation(UPDATE_USER);

  // console.log("User-key:::::::", shopId)

  // ==========> useLaztQuery And useMutation <==========
  const [getuser, { data: getuserData, loading }] = useLazyQuery(GET_USERS, {
    fetchPolicy: "network-only",
  });


  // ===============> UseEffect <==================
  // Update shop data when shop data change
  useEffect(() => {
    if (getuserData) {
      setUser(getuserData?.users?.data);
      setUserTotal(getuserData?.users?.total);
    }
  }, [getuserData]);

  useEffect(() => {
    _fetchUserdata();
  }, []);

  // Update shop data when shop data change

  // ===============> Fetch User Data <==================
  const _fetchUserdata = async () => {
    await getuser({
      variables: {
        limit: 500,
        where: {
          shop: shopId,
        },
      },
    });
  };

  // ===============> Function create new user <==================
  const _createUser = async (values) => {
    // console.log({ values });
    if (!values.nickname) {
      errorSwal("ກະລຸນາເພີ່ມຊື່...");
      return;
    }
    try {
      if (loadingCreate) return;
      await createUser({
        variables: {
          orderBy: "createdAt_DESC",
          data: {
            ...values,
          },
        },
      });
      _fetchUserdata();
      successSwal("ເພີ່ມສຳເລັດ");
      setshowAddUser(false);
    } catch (err) {
      errorSwal("ຜູ້ໃຊ້ນີ້ມີຢູ່ແລ້ວ");
      // console.log('error creating todo:', err)
    }
  };

  // ==========> fuction delete <==========
  const handleShowDelete = (id, nickname) => {
    setDelete({ nickname, id });
    setShowDelete(true);
  };

  const _confirmeDelete = async () => {
    try {
      if (loadingDelete) return;
      await deleteUser({
        variables: {
          where: {
            id: Delete.id,
          },
        },
      });

      _fetchUserdata();
      successDeleteSwal("ລົບສຳເລັດ");
      setShowDelete(false);
    } catch (err) {
      errorSwal("ການລົບຂໍ້ມູນບໍ່ສຳເລັດ !");
    }
  };

  // ===============> checkboxes function <==================
  const checkBoxChange = () => {
    setCountCheck(!countCheck);
    // {!countCheck ? setCheckBoxesState(true): setCheckBoxesState("") }
    if (!countCheck) {
      setCheckBoxesState(true);
    } else {
      setCheckBoxesState();
    }
  };

  // <============== Update Unit =================>
  const _updateUser = async (values) => {
    try {
      if (loadingUpdate) return;
      await updateUser({
        variables: {
          where: {
            id: userKey?.id,
          },
          data: {
            ...values,
          },
        },
      });
      successDeleteSwal("ເເກ້ໄຂຂໍ້ມູນສຳເລັດ");
      setShowEditUser(false);
      _fetchUserdata();
    } catch (err) {
      errorSwal("ລາຍການສິນຄ້ານີ້ມີຢູ່ແລ້ວ");
      // console.log("error creating todo:", err);
    }
  };

  return (
    <React.Fragment>
      <>
        <div className="em-manage">
          <div className="em-manage-top">
            <div>
              <p onClick={() => history.goBack()}>
                {" "}
                <ArrowBackIcon /> ກັບສູ່ໜ້າຫຼັກ
              </p>
            </div>
            <div>
              <h1>ຈັດການພະນັກງານ({userTotal}) </h1>
            </div>
            <div>
              <i
                className="fa fa-bell"
                style={{ color: colorBell, cursor: "pointer" }}
                onClick={() => setColorBell("#1F3A60")}
              >
                {" "}
                <NotificationsActiveIcon />
              </i>
            </div>
          </div>

          <div className="option-em">
            <div className="search-bar">
              <div className="input-icons">
                <i className="searchIcon">
                  {" "}
                  <SearchIcon />{" "}
                </i>
                <input
                  className="input-field"
                  type="text"
                  placeholder="ຄົ້ນຫາຊື່ ຫຼຶ ເບີໂທ..."
                  style={{ border: "none" }}
                />
              </div>
              {/* <div className="filter-em">
                <select>
                  <option value="All Employees">ເລືອກປະເພດສິນຄ້າ</option>
                  <option value="Active Employees">Active Employees</option>
                  <option value="Inactive Employees">Inactive Employees</option>
                </select>
                <select>
                  <option value="Sort By">ເລືອກແບບສິນຄ້າ</option>
                  <option value="Name">Name</option>
                  <option value="Date">Date</option>
                </select>
              </div> */}
            </div>
            <div className="button-em">
              <CustomButton
                width="165px"
                height="46px"
                title="ເພີ່ມພະນັກງານ"
                icon={<AddBoxOutlinedIcon />}
                borderRadius="8px"
                onClick={() => setshowAddUser(true)}
              />
            </div>
          </div>

          <div
            style={{
              paddingLeft: "20px",
              paddingRight: "20px",
            }}
          >
            {/* table */}
            {loading ? (
              <>
                <center>
                  <AnimationLoading />
                </center>
              </>
            ) : (
              <>
                {/* ================> Table part <================ */}
                {user?.length > 0 ? (
                  <Table
                    style={{
                      marginTop: "20px",
                      borderCollapse: "collapse",
                      width: "100% ",
                    }}
                  >
                    <thead
                      style={{
                        background: "#1F3A60",
                        borderRadius: " 8px 8px 0px 0px",
                        color: "#FFFFFF",
                      }}
                    >
                      <tr>
                        <th style={{ paddingTop: "1rem" }}>
                          <Form>
                            {["checkbox"].map((type) => (
                              <div key={type} className="mb-3">
                                <Form.Check
                                  type={type}
                                  id={`check-api-${type}`}
                                >
                                  <Form.Check.Input
                                    type={type}
                                    isValid
                                    onChange={() => {
                                      checkBoxChange();
                                    }}
                                  />
                                  <Form.Check.Label>{``}</Form.Check.Label>
                                  {/* <Form.Control.Feedback type="valid">
                                    You did it!
                                  </Form.Control.Feedback> */}
                                </Form.Check>
                              </div>
                            ))}
                          </Form>
                        </th>
                        <th>#</th>
                        <th>ຊື່ ແລະ ນາມສະກຸນ</th>
                        <th>user</th>
                        <th>ເບີໂທ</th>
                        <th>ສີດໃນການຈັດການ</th>
                        <th>ວັນທີທີ່ເພີ່ມ</th>
                        <th>ຈັດການ</th>
                      </tr>
                    </thead>
                    <tbody>
                      {user?.map((userType, index) => (
                        <tr key={index}>
                          <td style={{ paddingTop: "1rem" }}>
                            <Form>
                              {["checkbox"].map((type, index) => (
                                <div key={index} className="mb-3">
                                  <Form.Check
                                    type={type}
                                    id={`check-api-${type}`}
                                    key={index}
                                  >
                                    <Form.Check.Input
                                      type={userType?.index}
                                      key={index}
                                      isValid
                                      checked={checkboxesState}
                                    // onChange={()=> setCheckBoxesState(!checkboxesState)}
                                    />
                                    <Form.Check.Label>{``}</Form.Check.Label>
                                    {/* <Form.Control.Feedback type="valid">
                                      You did it!
                                    </Form.Control.Feedback> */}
                                  </Form.Check>
                                </div>
                              ))}
                            </Form>
                          </td>
                          <td style={{ paddingTop: "1rem" }}>{index + 1}</td>
                          <td style={{ paddingTop: "1rem" }}>
                            {userType?.nickname}
                          </td>
                          <td style={{ paddingTop: "1rem" }}>
                            {userType?.username}
                          </td>
                          <td style={{ paddingTop: "1rem" }}>
                            {userType?.phone}
                          </td>
                          <td style={{ paddingTop: "1rem" }}>
                            {userType?.role}
                          </td>
                          <td style={{ paddingTop: "1rem" }}>
                            {" "}
                            {moment(userType?.createdAt).format("DD/MM/YYYY")}
                          </td>

                          <td style={{ width: "30%" }}>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <CustomButton
                                key={index}
                                width="149px"
                                height="42px"
                                borderRadius="8px"
                                border="1px solid #3C169B"
                                title="ເເກ້ໄຂ"
                                color="#3C169B"
                                background="#F7F7F7"
                                icon={
                                  <MdOutlineBorderColor
                                    style={{
                                      color: "#3C169B",
                                      fontSize: "20px",
                                    }}
                                  />
                                }
                                onClick={() => {
                                  setShowEditUser(true);
                                  setUserKey(userType);
                                  setUserKeyIndex(index + 1);
                                }}
                              />
                              &ensp;
                              <CustomButton
                                width="149px"
                                height="42px"
                                margin="0"
                                title="ລົບ"
                                border="1px solid #DC2626"
                                borderRadius="8px"
                                background="#F7F7F7"
                                color="#DC2626"
                                onClick={() =>
                                  handleShowDelete(
                                    userType?.id,
                                    userType?.nickname
                                  )
                                }
                                icon={
                                  <RiDeleteBin6Line
                                    style={{
                                      color: "#D21C1C",
                                      fontSize: "20px",
                                    }}
                                  />
                                }
                              />
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                ) : (
                  <div
                    style={{
                      fontSize: "24px",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      // height: "100%",
                      // background:"red",
                      color: "#6B7280",
                      fontWeight: "400",
                    }}
                  >
                    <EmptyComponent />
                    <p>ຍັງບໍ່ມີປະເພດສິນຄ້າກະລຸນາໄປເພີ່ມປະເພດສິນຄ້າກ່ອນ !!!</p>
                  </div>
                )}
              </>
            )}
            {/* end table */}
          </div>

          {/* Confirm Delete */}

          <ConfirmDelete
            title={loadingDelete ? <Spinner /> : "ລົບ"}
            open={showDelete}
            text={Delete?.name}
            onClose={() => setShowDelete(false)}
            onSubmit={_confirmeDelete}
          />

          {/* create ProductType */}

          <Modal show={showAddUser} onHide={() => setshowAddUser(false)}>
            <Modal.Header closeButton>
              <Modal.Title>ເພີ່ມພັກນະງານ</Modal.Title>
            </Modal.Header>
            <Formik
              enableReinitialize={true}
              initialValues={{
                nickname: "",
                username: "",
                password: "",
                phone: "",
                role: "",

                shop: shopId,
              }}
              validate={(values) => {
                // const errors = {};
                // if (!values.userId) {
                //     errors.userId = 'ກະລຸນາປ້ອນ Userid... !';
                // }
                // return errors;
              }}
              onSubmit={async (values, { setSubmitting }) => {
                await _createUser(values);
              }}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
                /* and other goodies */
              }) => (
                <>
                  {/* ---------- Modal Add------------ */}

                  <Modal.Body>
                    <Form.Label>ຊື່ ແລະ ນາມສະກຸນ</Form.Label>
                    <Form.Control
                      type="text"
                      name="nickname"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.nickname}
                      placeholder={"ຊື່ ແລະ ນາມສະກຸນ..."}
                    />
                    <Form.Label>Username</Form.Label>
                    <Form.Control
                      type="text"
                      name="username"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.username}
                      placeholder="ຊື່ຜູ້ນໍາໃຊ້ລະບົບ..."
                    />
                    <Form.Label>Password</Form.Label>
                    <Form.Control
                      type="text"
                      name="password"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.password}
                      placeholder="ສ້າງລະຫັດຜ່ານ..."
                    />
                    <Form.Label>ເບີໂທ</Form.Label>
                    <Form.Control
                      type="text"
                      name="phone"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.phone}
                      placeholder="ເບີໂທ..."
                    />
                    <Form.Label>ສີດໃນການຈັດການ</Form.Label>
                    <Form.Select
                      aria-label="Default select example"
                      name="role"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.role}
                    >
                      <option>ເລືອກສິດໃນການຈັດການ</option>
                      <option value="ADMIN">ADMIN</option>
                      <option value="STAFF">STAFF</option>
                      <option value="SHOP">SHOP</option>
                      <option value="USER">USER</option>
                    </Form.Select>
                  </Modal.Body>
                  <Modal.Footer>
                    <CustomButton
                      title="ຍົກເລີກ"
                      width="100px"
                      background="#A9B3BD"
                      borderRadius="8px"
                      onClick={() => setshowAddUser(false)}
                    />
                    &emsp;
                    <CustomButton
                      title={loadingCreate ? <Spinner /> : "ບັນທຶກ"}
                      width="100px"
                      borderRadius="8px"
                      onClick={() => handleSubmit()}
                    />
                  </Modal.Footer>
                </>
              )}
            </Formik>
          </Modal>

          {/* ---------- Modal Edit------------ */}
          <Modal show={showEditUser} onHide={() => setShowEditUser(false)}>
            <Modal.Header closeButton>
              <Modal.Title>
                ແກ້ໄຂຂໍ້ມູນພະນັກງານລໍາດັບທີ {userKeyIndex}{" "}
              </Modal.Title>
            </Modal.Header>
            <Formik
              initialValues={{
                nickname: userKey?.nickname,
                username: userKey?.username,
                // userId: userKey?.id,

                phone: userKey?.phone,

                role: userKey?.role,

                shop: shopId,
              }}
              validate={(values) => {
                // const errors = {};
                // if (!values.userKey.id) {
                //   errors.userKey.id = "ກະລຸນາປ້ອນ Userid... !";
                // }
                // return errors;
              }}
              onSubmit={(values, { setSubmitting }) => {
                _updateUser(values);
              }}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
                /* and other goodies */
              }) => (
                <>
                  <Modal.Body>
                    <Form.Label>ຊື່ ແລະ ນາມສະກຸນ</Form.Label>
                    <Form.Control
                      // key={userKey}
                      type="text"
                      name="nickname"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.nickname}
                      placeholder={values.nickname}
                    />
                    <Form.Label>username</Form.Label>
                    <Form.Control
                      type="text"
                      name="username"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.username}
                      placeholder={values.username}
                    />
                    <Form.Label>ເບີໂທ</Form.Label>
                    <Form.Control
                      type="text"
                      name="phone"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.phone}
                      placeholder={values.phone}
                    />
                    <Form.Label>ສີດໃນການຈັດການ</Form.Label>
                    <Form.Select
                      aria-label="Default select example"
                      name="role"
                      value={values.role}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    >
                      <option>ເລືອກສິດໃນການຈັດການ</option>
                      <option value="ADMIN">ADMIN</option>
                      <option value="STAFF">STAFF</option>
                      <option value="SHOP">SHOP</option>
                      <option value="USER">USER</option>
                    </Form.Select>
                  </Modal.Body>

                  <Modal.Footer>
                    <CustomButton
                      title="ຍົກເລີກ"
                      width="100px"
                      background="#A9B3BD"
                      borderRadius="8px"
                      onClick={() => setShowEditUser(false)}
                    />
                    &emsp;
                    <CustomButton
                      title="ບັນທຶກ"
                      width="100px"
                      borderRadius="8px"
                      onClick={() => handleSubmit()}
                    />
                  </Modal.Footer>
                </>
              )}
            </Formik>
          </Modal>

          {/* end create ProductType */}
        </div>
      </>
    </React.Fragment>
  );
}

export default EmployeeManage;
